import { resolveHashFragment } from '../../../Form/utils/form-source.util';
import { REENTRY_PLANNING_TAB_HASHES } from '../constants/reentry-planning.constants';

const TAB_HASH_ENTRIES = Object.entries(REENTRY_PLANNING_TAB_HASHES);

/**
 * Tab label deep-linked by a URL hash (e.g. `#forms` → `Forms`), or `null` when the hash
 * does not name a tab.
 * @param {string | undefined | null} hash
 * @returns {string | null}
 */
export const resolveReentryPlanningTabFromHash = (hash) => {
  const fragment = resolveHashFragment(hash);
  const match = TAB_HASH_ENTRIES.find(([, tabHash]) => tabHash === fragment);
  return match ? match[0] : null;
};

/**
 * Hash to write when a tab is selected; tabs without a deep link clear it.
 * @param {string} tabLabel
 * @returns {string}
 */
export const resolveReentryPlanningTabHash = (tabLabel) => {
  const tabHash = REENTRY_PLANNING_TAB_HASHES[tabLabel];
  return tabHash ? `#${tabHash}` : '';
};
